import { Grid } from '@mui/material';
import CustomCard from 'components/CustomCard';
import { TFunction } from 'i18next';
import { FC } from 'react';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import WorkIcon from '@mui/icons-material/Work';

interface DataProps {
  totalEarned: number,
  totalPaid: number,
  balance730: number,
  t: TFunction,
}

const EmployeeTotalPayments: FC<DataProps> = (props) => {
  const { totalEarned, totalPaid, balance730, t } = props;
  
  // Include 730 balance in total earned calculation
  const totalEarnedWith730 = totalEarned + balance730;

  return (
    <Grid container spacing={3}>
      <Grid item md={4} xs={12}>
        <CustomCard
          title={t('employees.report.cost.totalearnings')}
          Icon={AttachMoneyIcon}
          color="#08c9f5"
          id={1}
          text={!totalEarnedWith730 ? '-' : totalEarnedWith730.toLocaleString('de-DE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }) + '€'}
        />
      </Grid>
      <Grid item md={4} xs={12}>
        <CustomCard
          title={t('employees.report.cost.paid')}
          Icon={AttachMoneyIcon}
          color="#03BF62"
          id={2}
          text={!totalPaid ? '-' : totalPaid.toLocaleString('de-DE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }) + '€'}
        />
      </Grid>
      <Grid item md={4} xs={12}>
        <CustomCard
          title={t('employees.report.cost.currentCredit')}
          Icon={WorkIcon}
          color="#E5412A"
          id={1}
          text={!(totalEarnedWith730 || totalPaid)
            ? '-'
            : (totalEarnedWith730 - totalPaid).toLocaleString('de-DE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }) + '€'}
        />
      </Grid>
    </Grid>
  );
};

export default EmployeeTotalPayments;